// extracted by mini-css-extract-plugin
module.exports = {"html":"html_html__3lIfO"};